import { Component, Input } from '@angular/core';
import { CandidateAvailability } from '../../../../api';
import { BaseShifts } from '../../constants/base-shifts';

@Component({
  selector: 'base-candidate-shifts-availability',
  templateUrl: './base-candidate-shifts-availability.component.html',
})
export class BaseCandidateShiftsAvailabilityComponent {
  @Input() candidateAvailability: CandidateAvailability;

  shifts = BaseShifts;

  trackByShift(_: number, item: { icon: string; control: string }) {
    return item.control;
  }
}
